import PouchLoadService from 'external-services/pouch-load-service/index';
import BookingService from "app/services/booking/booking.service";
import { IBooking } from "shared-types/index";
import { cloneDeep } from 'lodash';

const NS = 'DateRangeBookingsService';

export interface IPouchService {
  getLocalDbUpperDateLimit: () => Date;
}

export interface IBookingService {
  getBetweenDates: (from: Date, to: Date) => Promise<IBooking[]>;
}

class DateRangeBookingsService {
  private pouchService: IPouchService;

  // inject angularjs dependencies in setup.controller
  setup(pouchService: IPouchService): void {
    this.pouchService = pouchService;
  }

  /**
   * Gets bookings across a date range, taking into account local couch & full couch
   */
  getBookingsFromDateRange(fromDate: Date, toDate: Date): Promise<IBooking[]> {
    let result: IBooking[];
    let bookingsPromise: Promise<IBooking[]>;
    let bookingsReducedPromise: Promise<IBooking[]>;
    let getBookingsFromBothDbs = false;
    const isBeyondLocalDbDateRange: boolean = !PouchLoadService.isDateInLocalDBRange(fromDate) && PouchLoadService.isDateInLocalDBRange(toDate);

    if (isBeyondLocalDbDateRange) {
      getBookingsFromBothDbs = true;
      const limitDate: Date = this.pouchService.getLocalDbUpperDateLimit();
      const dayAfterLimitDate = cloneDeep(limitDate)
      dayAfterLimitDate.setDate(dayAfterLimitDate.getDate() + 1)
      bookingsPromise = BookingService.getBetweenDates(fromDate, limitDate);
      bookingsReducedPromise = BookingService.getBetweenDates(dayAfterLimitDate, toDate);
    }
    else {
      bookingsPromise = BookingService.getBetweenDates(fromDate, toDate);
    }

    return bookingsPromise
      .then((bookingsResult: IBooking[]) => {
        result = bookingsResult;
        return getBookingsFromBothDbs ? bookingsReducedPromise : null;
      })
      .then((bookingsResult2) => {
        if (bookingsResult2) {
          result = result.concat(bookingsResult2);
        }
        return result;
      })
  }
}

// singleton
const instance = new DateRangeBookingsService();
export default instance as DateRangeBookingsService;
